module.exports = __webpack_public_path__ + "static/media/test.09c302f8.png";